<template>
<div class="app-wrapper">
  <template v-if="user">
    <el-scrollbar class="main-container" viewClass="main-container-scrollbar-view"
                  wrap-class="main-container-scrollbar-wrapper">
      <navbar class="main-navbar"></navbar>
      <div class="app-main">
        <router-view :key="key"></router-view>
      </div>
    </el-scrollbar>
  </template>
</div>
</template>

<script>
import Navbar from "@/layouts/components/Navbar"

export default {
  name: "SecurityLayout",
  data() {
    return {}
  },
  components: {
    Navbar,
  },
  computed: {
    key() {
      return this.$route.path
    },
    user() {
      return this.$store.state.auth.user
    },
  },
  created() {
    let that = this
    //  验证是否登录
    let loadingInstance = that.$loading()
    that.$store.dispatch('auth/autoLogin').then(() => {
      loadingInstance.close()
    }).catch((err) => {
      console.log(err)
      loadingInstance.close()
      that.$router.push({path: '/login'})
    })
  },
  mounted() {

  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;

  .main-container {
    flex: 1;
    height: 100vh;
    background-color: #f0f2f5;

    :deep(.main-container-scrollbar-wrapper) {
      overflow-x: hidden !important;
    }

    :deep(.main-container-scrollbar-view) {
      min-height: 100vh;
      display: flex;
      flex-direction: column;

      .main-navbar {
        flex: 0 0 auto;
      }

      .app-main {
        background-color: #f0f2f5;
        flex: auto;
      }

      .main-footer {
        flex: 0 0 auto;
      }
    }
  }

  .full-loading {
    width: 100vw;
    height: 100vh;
  }
}
</style>
